import React, { useState } from 'react';
import { reviews, type Review } from '../data/content';
import { SectionTitle } from './SectionTitle';
import { Stars } from './Stars';
import { Reveal } from './Reveal';
import { ReviewForm } from './ReviewForm';
const initials = (name: string) => name.replace('.', '').split(' ').map(part => part[0]).join('').slice(0, 2).toUpperCase();
function ReviewCard({
  review
}: {
  review: Review;
}) {
  return <article className="rounded-2xl border border-gold/20 bg-night p-5" data-id="element-128" data-mp="1bi6riazk5e2t">
      <div className="flex items-center gap-3" data-id="element-129" data-mp="16pwxojvbntv9">
        <span aria-hidden="true" className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[linear-gradient(135deg,#C9A84C,#D4AF37)] font-sans text-[15px] font-bold text-night" data-id="element-130" data-mp="16p3x60myi0lk">
          {initials(review.name)}
        </span>
        <div className="min-w-0" data-id="element-131" data-mp="sr5mb57ugmat">
          <p className="font-sans text-[15px] font-semibold text-ivory" data-id="element-132" data-mp="spcg1r15843c">
            {review.name}
          </p>
          <p className="font-sans text-[13px] text-ivory/50" data-id="element-133" data-mp="nsci63eg67nb">{review.city}</p>
        </div>
        <Stars className="ml-auto" data-id="element-134" data-mp="3lx3fv53ldsms" />
      </div>

      <p className="mt-4 font-sans text-[15px] leading-relaxed text-ivory/85" data-id="element-135" data-mp="3qp39ygwzdrbg">
        “{review.text}”
      </p>
      <p className="mt-3 font-sans text-[13px] text-ivory/40" data-id="element-136" data-mp="3cyhwj7qaq9ky">{review.date}</p>
    </article>;
}
export function ReviewsSection() {
  const [showAll, setShowAll] = useState(false);
  const visible = showAll ? reviews : reviews.slice(0, 4);
  return <section className="bg-botanic px-5 py-10" data-id="element-137" data-mp="8kjhpyht5di7">
      <SectionTitle data-id="element-138" data-mp="djcybzse5kml">⭐ Quienes aplicaron esta guía nos recomiendan</SectionTitle>

      <div className="mt-6 space-y-3" data-id="element-139" data-mp="3vog4zoy0a4p4">
        {visible.map((review, i) => <Reveal key={review.name} delay={i < 4 ? i * 80 : 0} data-id="element-140" data-mp="3vo6fe2gvhzjy" data-mpi={i}>
            <ReviewCard review={review} data-id="element-141" data-mp="4hdcmu6flsdb" />
          </Reveal>)}
      </div>

      {!showAll && <button type="button" onClick={() => setShowAll(true)} className="mt-6 w-full min-h-[56px] rounded-[14px] border border-gold/50 px-5 py-4 font-sans text-[16px] font-semibold text-gold transition-all duration-150 active:scale-[0.97] hover:bg-gold/10" data-id="element-142" data-mp="2k8ri0xkr55ob">
          Ver más reseñas ({reviews.length - 4})
        </button>}

      <ReviewForm data-id="element-143" data-mp="pudnd8iim4n0" />
    </section>;
}